import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const initPartnerFilter = () => {
  const parent = $('.isotope-filter')
  if (parent.length != 0) {
    iso = new Isotope('.isotope-filter', {
      itemSelector: '.pt-partner__image',
      percentPosition: true,
      layoutMode: 'fitRows',
      transitionDuration: 0,
    })

    parent.imagesLoaded(function () {
      iso.layout()
    })
  }

  let selectedCategory = ''
  let searchText = ''

  const filterItems = () => {
    $('.pt-partner__image').show()
    if (selectedCategory === '' && searchText === '') {
      $('.pt-partner__type').show()
      if (iso) {
        iso.arrange({ filter: '*' })
      }
      return
    }

    $('.pt-partner__type').each(function () {
      const $categoryList = $(this)
      const categorySlug = $categoryList.data('type-slug')
      const matchesCategory =
        selectedCategory === '' || categorySlug === selectedCategory

      if (matchesCategory) {
        if (searchText === '') {
          $categoryList.show()
          if (iso) {
            iso.arrange({
              filter: selectedCategory === '' ? '*' : '.' + selectedCategory,
            })
          }
        } else {
          const $accordionItems = $categoryList.find('.pt-partner__image')
          let hasVisibleItems = false

          $accordionItems.each(function () {
            const itemTitle = $(this).attr('title').toLowerCase()
            const matchesSearch = itemTitle.includes(searchText.toLowerCase())

            if (matchesSearch) {
              $(this).show()
              hasVisibleItems = true
            } else {
              $(this).hide()
            }
          })
          $categoryList.toggle(hasVisibleItems)
        }
      } else {
        $categoryList.hide()
      }
    })
    if (iso) {
      iso.layout()
    }
  }

  $('.js-partner-select').on('change', function () {
    selectedCategory = $(this).val()
    filterItems()
  })
  $('.js-partner-input').on('input', function () {
    searchText = $(this).val().trim()
    filterItems()
  })

  $('.js-partner-input').on('keyup', function (e) {
    if ((e.key === 'Backspace' || e.key === 'Delete') && $(this).val() === '') {
      searchText = ''
      filterItems()
    }
  })
}

$(document).ready(function () {
  initPartnerFilter()
})

export default initPartnerFilter
